export default "__VITE_ASSET__CQirqjhY__"